function TextWithlabel(props) {
  const { id, label, text } = props;
  return (
    <div className="relative">
      <input
        type="text"
        disabled={true}
        value={text}
        className="bg-transparent border-1 peer block w-full appearance-none rounded-lg border-gray-300 px-2.5 pb-1.5 pt-3 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
        placeholder=" "
      />
      <label
        htmlFor={"text_with_label" + id}
        className="absolute top-1 origin-[0] -translate-y-3 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 start-1 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1 peer-focus:-translate-y-3 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600  dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500"
      >
        {label}
      </label>
    </div>
  );
}

export default TextWithlabel;
